import skipToContentTemplate from './skip_to_content.template.html';

class WbSkipToContentController {

    constructor($window) {
        'ngInject';

        const injectables = {
            $window
        };

        Object.assign(this, injectables);
    }

    $onInit() {
    }

    skipToContent() {
        let element = this.$window.document.getElementById('main-content');
        element.focus();
    }
}

const WbSkipToContentComponent = {
    templateUrl: skipToContentTemplate.id,
    controller: WbSkipToContentController,
    controllerAs: '$wbSkipToContentCtrl'
};

angular
    .module('westBerkshireEvents.skipToContent')
    .component('wbSkipToContent', WbSkipToContentComponent);

export default WbSkipToContentController;


// WEBPACK FOOTER //
// ../src/public/javascripts/skip-to-content/skip_to_content.component.js